import { UNCLASSIFIED } from 'constants/categories'

import { getCategoryForURL } from '../utils/blockingList'


/**
 * @param {string} src
 *
 * @returns {string} the comma-delimited categories that `src` answers to
 */
export default function getCategoryForSrc(src) {
  const url = new URL(src, window.location)

  return getCategoryForURL(url) || UNCLASSIFIED
}
